(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bump-cart"]) return;
  try {
    

  document.querySelectorAll("[id^='BumpDrawer-']").forEach((element) => {
    const msDelay = Number(element.dataset.delay) * 1000;

  if (document.querySelector("[id^='BumpDrawer-']").classList.contains("toCart")) return; 
  else {
    if (msDelay >= 0) {
      setTimeout(() => {
        element.show();
      }, msDelay);
    }
  };
  });

  /* Offer Timer */
  const countdownTimer = document.getElementById('offer-timer-countdown');
  let minutes = 2;
  let seconds = 00;

  function updateTimer() {
    // Format time string with leading zeros
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = seconds.toString().padStart(2, '0');
    if (countdownTimer)
      countdownTimer.textContent = `${formattedMinutes}:${formattedSeconds}`;

    // Decrement seconds and update minutes if necessary
    seconds--;
    if (seconds === -1) {
      seconds = 59;
      minutes--;
    }

    // Check if timer has reached zero
    if (minutes === 0 && seconds === 0) {
      minutes = 2
    }
  }
  // Start the timer with an interval of 1 second
  function startTimer(){
    minutes = 2
    secionds = 00
  }

  const intervalId = setInterval(updateTimer, 1000);

  // Update the timer initially (optional)
  updateTimer();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.body = document.querySelector('body');
      this.mql = window.matchMedia(`(min-width: ${
        window.breakpoints.lg
      }px)`);
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.onMediaMatchHandler = this.createObserver.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.mql.addListener(this.onMediaMatchHandler);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.mql.removeListener(this.onMediaMatchHandler)
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header)
    }
 
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = Math.abs(scrollTop);
    } 

    hide() {
      this.body.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.body.classList.remove('shopify-header-revealed');
    }

    reveal() {
      this.body.classList.add('shopify-section-header-sticky', 'animate', 'shopify-header-revealed');
      this.body.classList.add('shopify-header-revealed');
      this.body.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.body.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

  /*
  const pinchZoom = (imageElement) => {
    let imageElementScale = 1;

    let start = {};

    // Calculate distance between two fingers
    const distance = (event) => {
      return Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
    };

    imageElement.addEventListener('touchstart', (event) => {
      console.log('touchstart', event);
      if (event.touches.length === 2) {
        event.preventDefault(); // Prevent page scroll

        // Calculate where the fingers have started on the X and Y axis
        start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2;
        start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2;
        start.distance = distance(event);
      }
    });

    imageElement.addEventListener('touchmove', (event) => {
      console.log('touchmove', event);
      if (event.touches.length === 2) {
        event.preventDefault(); // Prevent page scroll
        let scale;

        // Safari provides event.scale as two fingers move on the screen
        // For other browsers just calculate the scale manually
        if (event.scale) {
          scale = event.scale;
        } else {
          const deltaDistance = distance(event);
          scale = deltaDistance / start.distance;
        }

        imageElementScale = Math.min(Math.max(1, scale), 4);

        // Calculate how much the fingers have moved on the X and Y axis
        const deltaX = (((event.touches[0].pageX + event.touches[1].pageX) / 2) - start.x) * 2; // x2 for accelarated movement
        const deltaY = (((event.touches[0].pageY + event.touches[1].pageY) / 2) - start.y) * 2; // x2 for accelarated movement

        // Transform the image to make it grow and move with fingers
        const transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${imageElementScale})`;
        imageElement.style.transform = transform;
        imageElement.style.WebkitTransform = transform;
        imageElement.style.zIndex = "9999";
      }
    });


  }
  document.querySelectorAll('.product-image-modal__content > *').forEach(image => {
    console.log('pinchZoom turning on.')
    pinchZoom(image)
  });
  */



  document.querySelectorAll('product-form button[type="submit"]').forEach((element) => {
    element.addEventListener('click', (event) => {
      const selector = document.querySelector('.product__info-wrapper');

      const matches = window.matchMedia('(max-width: 767px)').matches;

      if (matches) {
        selector.scrollIntoView({behavior: 'smooth'});
      }
    });
  });

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-image-id]:not([data-image-id="${
        this.openedBy.getAttribute('data-image-id')
      }"])`).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-image-id="${
        this.openedBy.getAttribute('data-image-id')
      }"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate
        ? activeMediaTemplate.content
        : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      if(container)
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube')) 
        activeMedia.loadContent();
      



    }
  }

  customElements.define('product-modal', ProductModal);

  class ImageNavigation extends HTMLElement {
    constructor() {
      super();

      this.bindEvents();
    }

    bindEvents() {
      const root = document.querySelector(this.querySelector('a').getAttribute('href')).parentElement;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const element = this.querySelector(`[href='#${
            entry.target.id
          }']`);
          if (entry.isIntersecting) {
            element.setAttribute('aria-current', 'location');
            element.classList.add('active');
          } else {
            element.removeAttribute('aria-current');
            element.classList.remove('active');
          }
        });
      }, {root, threshold: 0.5});

      [...this.querySelectorAll('a')].forEach((element) => {
        const image = document.querySelector(element.getAttribute('href'));
        observer.observe(image);
        element.addEventListener('click', this.onClick.bind(this));
      });
    }

    onClick(event) {
      event.preventDefault();
      const image = document.querySelector(event.currentTarget.getAttribute('href'));
      document.querySelector('sticky-header').dispatchEvent(new CustomEvent('preventHeaderReveal'));
      image.scrollIntoView({behavior: 'smooth'});
    }
  }

  customElements.define('image-navigation', ImageNavigation);

  function logViewedProduct() {
    const productId = Number(document.getElementById('MainProduct').dataset.productId);
    const storageKey = 'viewed_products';

    try {
      let history = JSON.parse(window.localStorage.getItem(storageKey));

      if (Array.isArray(history)) {
        const index = history.findIndex((seenId) => seenId === productId);
        if (index >= 0) {
          history.splice(index, 1);
        }
        history.unshift(productId);
      } else {
        history = [productId];
      }

      window.localStorage.setItem(storageKey, JSON.stringify(history));
    } catch (error) {
      window.localStorage.setItem(storageKey, JSON.stringify([productId]));
    }
  }

  logViewedProduct();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
    let timeout;

    const handlePopup = (element) => {
        clearTimeout(timeout);
        const hasSeenPopup = !!window.localStorage.getItem(element.id);
        if (!hasSeenPopup || Shopify.designMode) {
            const delay = element.dataset.delay || 0;
            timeout = setTimeout(() => {
                element.show();
                window.localStorage.setItem(element.id, true);
            }, delay * 1000);
        }
    }

    window.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.popup').forEach((element) => {
            handlePopup(element);
        });
    });

    window.addEventListener('shopify:section:load', (event) => {
        const element = document.getElementById(event.detail.section.id);
        if (element) handlePopup(element);
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', function () {
    window.loadScript(
      'https://widget.reviews.io/polaris/build.js',
      function () {
        function stripHTML(html) {
          return new DOMParser().parseFromString(html, 'text/html').body.textContent || '';
        }

        function stripNewlines(text) {
          return text.replace(/(\r\n|\n|\r)/gm, '');
        }

        document.querySelectorAll(`[id^='ProductReviews-']`).forEach(function (element) {
          const product = JSON.parse(element.querySelector('[type="application/json"]').textContent);
          const selector = `#ProductReviewsContent-${element.dataset.sectionId}`;

          new ReviewsWidget(selector, {
            //Your REVIEWS.io account ID and widget type:
            store: 'musclenation.org',
            widget: 'polaris',

            //Content settings (store_review,product_review,questions). Choose what to display in this widget:
            options: {
              types: 'product_review',
              lang: 'en',
              //How many reviews & questions to show per page?
              per_page: 5,
              //Product specific settings. Provide product SKU for which reviews should be displayed:
              product_review: {
                //Display product reviews - include multiple product SKUs seperated by Semi-Colons (Main Indentifer in your product catalog )
                sku: product.variants
                  .reduce((acc, { sku, id }) => {
                    acc.push(sku, id);
                    return acc;
                  }, [])
                  .join(';'),
                enable_rich_snippets: true,

                /* Your custom Structured Data */
                structured_data: {
                  category: product.type,
                  url: `${window.location.origin}/products/${product.handle}`,
                  image: product.images.map((image) => `https:${image}`),
                  ...(product.description && {
                    description: stripNewlines(stripHTML(product.description)),
                  }),
                  offers: product.variants.map((variant) => ({
                    type: 'Offer',
                    priceCurrency: window.Shopify.currency.active,
                    price: (variant.price / 100).toFixed(2),
                    itemCondition: 'http://schema.org/NewCondition',
                    availability: variant.available ? 'http://schema.org/InStock' : 'http://schema.org/OutOfStock',
                    url: `${window.location.origin}/products/${product.handle}?variant=${variant.id}`,
                    image: variant.featured_image
                      ? `https:${variant.featured_image}`
                      : `https:${product.featured_image}`,
                    name: product.title + (variant.title !== 'Default Title' ? ` - ${variant.title}` : ''),
                    ...(variant.barcode.length == 12 && {
                      gtin12: variant.barcode,
                    }),
                    ...(variant.barcode.length == 13 && {
                      gtin13: variant.barcode,
                    }),
                    ...(variant.barcode.length == 14 && {
                      gtin14: variant.barcode,
                    }),
                    ...(variant.sku && {
                      sku: variant.sku,
                    }),
                    ...(variant.description && {
                      description: stripNewlines(stripHTML(variant.description)),
                    }),
                    priceValidUntil: new Date(new Date().getTime() + 31557600000).toISOString(),
                  })),
                  brand: {
                    type: 'Brand',
                    name: product.vendor,
                  },
                },
                /* Your custom Structured Data */
              },
              //Header settings:
              header: {
                enable_summary: true, //Show overall rating & review count
                enable_ratings: true,
                enable_attributes: true,
                enable_image_gallery: true, //Show photo & video gallery
                enable_percent_recommended: false, //Show what percentage of reviewers recommend it
                enable_write_review: true, //Show "Write Review" button
                enable_ask_question: false, //Show "Ask Question" button
                enable_sub_header: true, //Show subheader
              },

              //Filtering settings:
              filtering: {
                enable: true, //Show filtering options
                enable_text_search: false, //Show search field
                enable_sorting: true, //Show sorting options (most recent, most popular)
                enable_overall_rating_filter: true, //Show overall rating breakdown filter
                enable_ratings_filters: true, //Show product attributes filter
                enable_attributes_filters: true, //Show author attributes filter
              },

              //Review settings:
              reviews: {
                enable_replies: true, // Show review replies
                enable_avatar: true, //Show author avatar
                enable_reviewer_name: true, //Show author name
                enable_reviewer_address: true, //Show author location
                reviewer_address_format: 'city, country', //Author location display format
                enable_verified_badge: true, //Show "Verified Customer" badge
                enable_reviewer_recommends: true, //Show "I recommend it" badge
                enable_attributes: true, //Show author attributes
                enable_product_name: true, //Show display product name
                enable_images: true, //Show display review photos
                enable_ratings: true, //Show product attributes (additional ratings)
                enable_share: true, //Show share buttons
                enable_helpful_vote: true, //Show "was this helpful?" section
                enable_helpful_display: true, //Show how many times times review upvoted
                enable_report: true, //Show report button
                enable_date: true, //Show when review was published,
                enable_original_aspect: true,
              },
              footer: {
                enable_footer_logo: false,
              },
            },
            //Style settings:
            styles: {
              //Base font size is a reference size for all text elements. When base value gets changed, all TextHeading and TexBody elements get proportionally adjusted.
              '--base-font-size': '16px',

              //Button styles (shared between buttons):
              '--common-button-font-family': 'inherit',
              '--common-button-font-size': '0.875rem',
              '--common-button-font-weight': '700',
              '--common-button-letter-spacing': '0',
              '--common-button-text-transform': 'uppercase',
              '--common-button-vertical-padding': '0.25rem',
              '--common-button-horizontal-padding': '1rem',
              '--common-button-border-width': '1px',
              '--common-button-border-radius': '0.125rem',

              //Primary button styles:
              '--primary-button-bg-color': 'rgb(var(--color-gray-900))',
              '--primary-button-border-color': 'rgb(var(--color-gray-900))',
              '--primary-button-text-color': 'rgb(var(--color-white))',

              //Secondary button styles:
              '--secondary-button-bg-color': 'transparent',
              '--secondary-button-border-color': 'rgb(var(--color-gray-900))',
              '--secondary-button-text-color': 'rgb(var(--color-gray-900))',

              //Star styles:
              '--common-star-color': '#0E1311',
              '--common-star-disabled-color': 'rgba(0,0,0,0.25)',
              '--medium-star-size': '1.5rem',
              '--small-star-size': '1rem',

              //Heading styles:
              '--heading-text-color': 'rgb(var(--color-gray-900))',
              '--heading-text-font-weight': 'inherit',
              '--heading-text-font-family': 'inherit',
              '--heading-text-line-height': 'inherit',
              '--heading-text-letter-spacing': '0',
              '--heading-text-transform': 'uppercase',

              //Body text styles:
              '--body-text-color': 'rgb(var(--color-gray-900))',
              '--body-text-font-weight': '400',
              '--body-text-font-family': 'inherit',
              '--body-text-line-height': 'inherit',
              '--body-text-letter-spacing': '0',
              '--body-text-transform': 'none',

              //Input field styles:
              '--inputfield-text-font-family': 'inherit',
              '--input-text-font-size': '1rem',
              '--inputfield-text-font-weight': '400',
              '--inputfield-text-color': 'rgb(var(--color-gray-900))',
              '--inputfield-border-color': 'rgba(0,0,0,0.2)',
              '--inputfield-background-color': 'transparent',
              '--inputfield-border-width': '1px',
              '--inputfield-border-radius': '0.125rem',

              '--common-border-color': 'rgb(var(--color-gray-200))',
              '--common-border-width': '1px',
              '--common-sidebar-width': '190px',

              //Slider indicator (for attributes) styles:
              '--slider-indicator-bg-color': 'rgba(0,0,0,0.1)',
              '--slider-indicator-button-color': '#0E1311',
              '--slider-indicator-width': '190px',

              //Badge styles:
              '--badge-icon-color': '#0E1311',
              '--badge-icon-font-size': 'inherit',
              '--badge-text-color': '#0E1311',
              '--badge-text-font-size': 'inherit',
              '--badge-text-letter-spacing': 'inherit',
              '--badge-text-transform': 'inherit',

              //Author styles:
              '--author-font-size': 'inherit',
              '--author-text-transform': 'none',

              //Author avatar styles:
              '--avatar-thumbnail-size': '60px',
              '--avatar-thumbnail-border-radius': '100px',
              '--avatar-thumbnail-text-color': '#0E1311',
              '--avatar-thumbnail-bg-color': 'rgba(0,0,0,0.1)',

              //Product photo or review photo styles:
              '--photo-video-thumbnail-size': '80px',
              '--photo-video-thumbnail-border-radius': '0px',

              //Media (photo & video) slider styles:
              '--mediaslider-scroll-button-icon-color': '#0E1311',
              '--mediaslider-scroll-button-bg-color': 'rgba(255, 255, 255, 0.85)',
              '--mediaslider-overlay-text-color': '#ffffff',
              '--mediaslider-overlay-bg-color': 'rgba(0, 0, 0, 0.8))',
              '--mediaslider-item-size': '110px',

              //Pagination & tabs styles (normal):
              '--pagination-tab-text-color': '#0E1311',
              '--pagination-tab-text-transform': 'none',
              '--pagination-tab-text-letter-spacing': '0',
              '--pagination-tab-text-font-size': '16px',
              '--pagination-tab-text-font-weight': '600',

              //Pagination & tabs styles (active):
              '--pagination-tab-active-text-color': '#0E1311',
              '--pagination-tab-active-text-font-weight': '600',
              '--pagination-tab-active-border-color': '#0E1311',
              '--pagination-tab-border-width': '3px',
            },
          });
        });
      },
      function (error) {
        console.error(error);
      }
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-products"] && !Shopify.designMode) return;
  try {
    
  const observer = new IntersectionObserver(
    (entries) => {
      for (let entry of entries) {
        if (entry.isIntersecting) {
          document.dispatchEvent(new CustomEvent('load_recommended_products'));
        }
      }
    },
    { margin: '400px 0px' }
  );

  document.querySelectorAll("[id^='RecommendedProducts-']").forEach((element) => {
    observer.observe(element);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-announcement-bar"] && !Shopify.designMode) return;
  try {
    
// JavaScript goes here

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viewed-products"] && !Shopify.designMode) return;
  try {
    
  const observer = new IntersectionObserver(
    (entries) => {
      for (let entry of entries) {
        if (entry.isIntersecting) {
          document.dispatchEvent(new CustomEvent('load_viewed_products'));
        }
      }
    },
    { margin: '400px 0px' }
  );

  document.querySelectorAll("[id^='ViewedProducts-']").forEach((element) => {
    observer.observe(element);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wished-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.wished-product-recommendations').forEach((section) => {
    const onReady = async (swat) => {
      const [wishedItems, cart] = await Promise.all([
        new Promise((resolve) => swat.fetch(resolve)),
        fetch(`${window.routes.cart_url}.js`).then((response) => response.json()),
      ]);

      const items = wishedItems.filter((wishedItem) =>
        cart.items.every((lineItem) => lineItem.product_id !== wishedItem.empi)
      );

      if (items.length < 2) return;

      const sectionToRender = 'wished-product-recommendation';
      const sectionToFill = section.querySelector('.grid');

      const elements = await Promise.all(
        items.slice(0, 2).map(async ({ du, epi, empi }, index) =>
          fetch(`${du}?sections=${sectionToRender}&variant=${epi}`)
            .then((response) => response.json())
            .then((json) => {
              const listItemElement = document.createElement('li');
              listItemElement.dataset.productId = empi;
              listItemElement.dataset.variantId = epi;
              listItemElement.dataset.productUrl = du;
              listItemElement.classList.add('grid__item');
              listItemElement.innerHTML = json[sectionToRender];
              return listItemElement;
            })
        )
      );

      elements.forEach((element) => {
        sectionToFill.appendChild(element);

        const onSubmit = async () => {
          if ('_swat' in window) {
            await new Promise((resolve) => {
              window._swat.addToCart(
                {
                  epi: element.dataset.variantId,
                  empi: element.dataset.productId,
                  du: element.dataset.productUrl,
                },
                resolve
              );
            });
          }
        };

        element.addEventListener('submit', onSubmit);
      });

      section.classList.remove('hidden');
      window.lazyloadPolyfill(section);
      window.convertCurrency(section);
    };

    if ('_swat' in window) {
      this.onReady(window._swat);
    } else {
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(onReady);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
